import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field } from "redux-form";
import moment from "moment";
import { renderFieldText } from "@basecomponent";
import LocaleStrings from "@language";

const CompnayDetails = (props) => {
  let { formValues, RSVPSessionsData, eventSettingsData, eventData } = props;

  return (
    <>
      <div className="rounded-xl border border-default">
        <div className="rounded-t-xl border-b border-default bg-default px-6 py-4">
          <div className="custom-text-primary-md-medium">
            {"Company Information"}
            {<span className="label-mandatory">*</span>}
          </div>
          <div className="custom-text-secondary-sm-medium">
            {"Enter the company details"}
          </div>
        </div>
        <dl className="base-form px-6 py-4">
          <Field
            name={"companyinfo"}
            label={"Company Name"}
            type={"text"}
            component={renderFieldText}
            mandatory={true}
            // disabled={false}
            // maxlength={maxLength}
            // onChange={handleLastFieldChanged}
          />
        </dl>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return { eventData: state.eventData };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CompnayDetails);
